import './MortgageBuyOrDie.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';

import Icon from '@vtblife/uikit-icons'; // TODO

import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import Image from '../../Image';

import mortgageBuyOrDieImg from './mortgageBuyOrDieImg.url.svg';

const cn = classname.bind(null, 'MortgageBuyOrAccTrigger');

export function MortgageBuyOrDieTrigger({ onClick, className }: { onClick(): void; className?: string }) {
    const staticPath = useStaticPathConfig();

    return (<div className={cn('', undefined, className)} onClick={onClick}>
        <Image url={`${staticPath}${mortgageBuyOrDieImg}`} />
        <div className={cn('texts')}>
            <Typography bold variant='secondary-alone'>
                Что сейчас выгоднее: арендовать и&nbsp;копить или купить квартиру&nbsp;в&nbsp;ипотеку?
                {/* eslint-disable-next-line react/jsx-indent */}
                <Typography tag='span' bold color='link' className={cn('link-hover')}>
                    &ensp;Рассчитать&nbsp;➔
                    {/* TODO ICON */}
                    {/* <i
                        // eslint-disable-next-line max-len
                        style={{ lineHeight: 16, display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle', marginLeft: 8 }}
                    >
                        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M11.13 7.25 7.88 4l1.06-1.06L14 8l-5.06 5.06L7.88 12l3.25-3.25h-9.2v-1.5h9.2Z' fill='#221F2E' /></svg>
                    </i> */}
                </Typography>
            </Typography>
            <Typography variant='small' color='secondary'>Калькулятор рентабельности поможет сделать правильный выбор</Typography>
        </div>
    </div>);
}
